var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00353 4.87454C0.913838 3.16304 2.1962 2.07676 4.8457 1.61595L5.01327 1.60717C7.40113 1.48203 24.2485 1.19777 30.9177 2.04559C31.8312 2.35959 32.3117 2.99428 32.3616 3.94688L32.4464 5.5655C31.2567 6.58041 29.7243 7.13966 27.8613 7.23729C18.273 7.17571 1.11784 7.0557 1.04094 5.58832L1.00353 4.87454Z",
    fill: "#F03B38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36523 16.326C2.36523 14.6121 3.68823 13.5945 6.33422 13.2729H6.50051C8.87261 13.2729 23.115 13.8708 29.6713 15.0665C30.559 15.4279 31.0016 16.0868 31.0016 17.0408V18.6616C29.7691 19.6128 28.226 20.0911 26.3772 20.0911C16.8888 19.5278 2.36523 18.5101 2.36523 17.0408V16.326Z",
    fill: "#F03B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 27.7277C1 26.2721 2.3964 25.5454 5.19415 25.5454C12.6598 25.9662 26.9412 26.1778 28.1987 26.1778H28.3724C29.8184 26.1778 30.8204 26.0743 31.3884 25.8627C32.946 26.1019 33.7273 26.7757 33.7273 27.8841V29.2776C33.7273 30.4251 19.8972 31 12.0695 31C4.80227 31 1.16866 30.3262 1.16866 28.974L1 27.8841V27.7277Z",
    fill: "#F03B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMenu);
export default __webpack_public_path__ + "static/media/footer-menu.a91230146d82f2efad2f231c53baf42e.svg";
export { ForwardRef as ReactComponent };